module.exports = __webpack_public_path__ + "static/media/story_thumbnail.2ce0b976.png";